export const ORDER_STATUS_OPTIONS = [
  { value: "order_placed", label: "Order Placed" },
  { value: "processing", label: "Processing" },
  { value: "dispatched", label: "Dispatched" },
  { value: "delivered", label: "Delivered" },
  { value: "cancelled", label: "Cancelled" },
];

export function normalizeOrderStatus(value) {
  const status = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  return ORDER_STATUS_OPTIONS.some((option) => option.value === status)
    ? status
    : "order_placed";
}

export function getOrderStatusLabel(value) {
  const status = normalizeOrderStatus(value);
  return ORDER_STATUS_OPTIONS.find((option) => option.value === status)?.label || "Order Placed";
}

export function getOrderStatusClass(value) {
  const status = normalizeOrderStatus(value);
  if (status === "delivered") return "bg-green-100 text-green-700 border-green-200";
  if (status === "cancelled") return "bg-red-100 text-red-700 border-red-200";
  if (status === "dispatched") return "bg-blue-100 text-blue-700 border-blue-200";
  if (status === "processing") return "bg-amber-100 text-amber-700 border-amber-200";
  return "bg-gray-100 text-gray-700 border-gray-200";
}
